// assets/kwik-override-pdp.js
(function () {
  const isPDP =
    document.body.classList.contains('template-product') || /\/products\//.test(location.pathname);
  if (!isPDP) return;

  if (window.__kwikPdpOverrideInitialized) return;
  window.__kwikPdpOverrideInitialized = true;

  console.log('[KWIK] PDP override loaded');

  const openKwikCart = () => {
    console.log('[KWIK] openKwikCart()');

    // ✅ Best: click the actual kwik icon (because that triggers refresh)
    const kwikIcon = document.getElementById('cart-icon-bubble');
    if (kwikIcon && kwikIcon.hasAttribute('data-open-cart')) {
      kwikIcon.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      return true;
    }

    // Fallback
    const btn = document.querySelector('[data-open-cart]');
    if (btn) {
      btn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      return true;
    }

    return false;
  };

  const disableDawnOpeners = () => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.open = function () {};
      cartDrawer.renderContents = function () {};
    }

    const cartNotification = document.querySelector('cart-notification');
    if (cartNotification) {
      cartNotification.open = function () {};
      cartNotification.renderContents = function () {};
    }
  };

  disableDawnOpeners();

  const ajaxAdd = async (form) => {
    if (form.dataset.kwikSubmitting === 'true') return;
    form.dataset.kwikSubmitting = 'true';

    const submitBtn = form.querySelector('button[type="submit"][name="add"], button[type="submit"]');
    const spinner = submitBtn?.querySelector('.loading-overlay__spinner');

    if (submitBtn) {
      submitBtn.setAttribute('aria-disabled', 'true');
      submitBtn.disabled = true;
    }
    if (spinner) spinner.classList.remove('hidden');

    try {
      const fd = new FormData(form);

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { Accept: 'application/json' },
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        console.error('[KWIK] add-to-cart failed:', err);
        return;
      }

      // ✅ open kwik (refresh is handled by kwik click)
      openKwikCart();
    } finally {
      delete form.dataset.kwikSubmitting;

      if (spinner) spinner.classList.add('hidden');
      if (submitBtn) {
        submitBtn.removeAttribute('aria-disabled');
        submitBtn.disabled = false;
      }
    }
  };

  // ✅ MAIN: intercept add-to-cart button click (works even when submit isn’t used)
  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest('button[name="add"][type="submit"], button.product-form__submit');
      if (!btn) return;

      const form = btn.closest('form[action="/cart/add"], form[action*="/cart/add"]');
      if (!form) return;

      console.log('[KWIK] Add to cart button clicked - intercepting');

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      disableDawnOpeners();
      ajaxAdd(form);
    },
    true
  );

  // Optional backup: submit capture
  document.addEventListener(
    'submit',
    (e) => {
      const form = e.target.closest('form[action="/cart/add"], form[action*="/cart/add"]');
      if (!form) return;

      console.log('[KWIK] submit captured - intercepting');

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      disableDawnOpeners();
      ajaxAdd(form);
    },
    true
  );

  // If Dawn re-renders DOM, keep it suppressed
  setInterval(disableDawnOpeners, 1500);
})();


//  Instant Support

// assets/kwik-instant-override.js
(function () {
  if (window.__kwikInstantOverrideInitialized) return;
  window.__kwikInstantOverrideInitialized = true;

  const clickKwikIcon = () => {
    const icon = document.getElementById('cart-icon-bubble');
    if (icon && icon.hasAttribute('data-open-cart')) {
      icon.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      return true;
    }
    const fallback = document.querySelector('[data-open-cart]');
    if (fallback) {
      fallback.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      return true;
    }
    return false;
  };

  const ajaxAddVariant = async (variantId, qty = 1) => {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(qty) || 1 }] }),
    });
    if (!res.ok) throw await res.json().catch(() => ({}));
    return res.json();
  };

  const setLoading = (el, isLoading) => {
    if (!el) return;

    // Wrap the current content once so we can hide it via CSS
    if (!el.querySelector('.kwik-atc-label')) {
      const wrap = document.createElement('span');
      wrap.className = 'kwik-atc-label';
      // move all children into wrap
      while (el.firstChild) wrap.appendChild(el.firstChild);
      el.appendChild(wrap);
    }

    el.classList.toggle('kwik-loading', !!isLoading);
    el.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  };

  document.addEventListener(
    'click',
    async (e) => {
      const instantAdd = e.target.closest('a[data-instant-action-type="add-to-instant-cart"]');
      if (!instantAdd) return;

      // Stop redirect to /cart/...
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (instantAdd.dataset.kwikBusy === 'true') return;
      instantAdd.dataset.kwikBusy = 'true';

      setLoading(instantAdd, true);

      try {
        const variantId =
          instantAdd.getAttribute('data-instant-action-variant-id') ||
          instantAdd.closest('form')?.getAttribute('data-instant-form-variant-id');

        if (!variantId) {
          console.warn('[KWIK] Variant ID not found for instant add-to-cart');
          return;
        }

        await ajaxAddVariant(variantId, 1);

        // Open kwik drawer (refresh happens via click)
        clickKwikIcon();
      } catch (err) {
        console.error('[KWIK] Instant override add failed:', err);
      } finally {
        setLoading(instantAdd, false);
        delete instantAdd.dataset.kwikBusy;
      }
    },
    true
  );
})();


// ===============================
// KWIK Bubble Fix (sync Dawn bubble with real cart count)
// Paste at the end of the file
// ===============================
(function () {
  if (window.__kwikBubbleFixInit) return;
  window.__kwikBubbleFixInit = true;

  const getCartCount = async () => {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const cart = await res.json();
    return cart?.item_count ?? 0;
  };

  const setBubbleCount = (count) => {
    const btn = document.getElementById('cart-icon-bubble');
    if (!btn) return;

    // Ensure bubble exists
    let bubble = btn.querySelector('.cart-count-bubble');
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = `
        <span aria-hidden="true">0</span>
        <span class="visually-hidden">0 items</span>
      `;
      btn.appendChild(bubble);
    }

    // Replace (no increment / no append)
    const visible = bubble.querySelector('span[aria-hidden="true"]') || bubble.querySelector('span');
    const sr = bubble.querySelector('.visually-hidden');

    if (count <= 0) {
      bubble.style.display = 'none';
      if (visible) visible.textContent = '0';
      if (sr) sr.textContent = '0 items';
      return;
    }

    bubble.style.display = '';
    if (visible) visible.textContent = String(count);
    if (sr) sr.textContent = `${count} ${count === 1 ? 'item' : 'items'}`;
  };

  const refreshBubble = async () => {
    try {
      const count = await getCartCount();
      setBubbleCount(count);
    } catch (_) {}
  };

  // 1) initial
  refreshBubble();

  // 2) hook fetch to refresh after ANY cart update
  const _fetch = window.fetch;
  window.fetch = async (...args) => {
    const res = await _fetch(...args);

    try {
      const [input, init] = args;
      const url = typeof input === 'string' ? input : input?.url || '';
      const method = (init?.method || 'GET').toUpperCase();

      // cart endpoints that change count
      if (method !== 'GET' && /\/cart\/(add|change|update|clear)\.js(\?|$)/.test(url)) {
        setTimeout(refreshBubble, 200);
      }
    } catch (_) {}

    return res;
  };

  // 3) also refresh when kwik drawer is opened (click on icon)
  document.addEventListener(
    'click',
    (e) => {
      const icon = e.target.closest('#cart-icon-bubble');
      if (icon) setTimeout(refreshBubble, 200);
    },
    true
  );
})();